import script from "./AdventureChatTypingIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./AdventureChatTypingIndicator.vue?vue&type=script&setup=true&lang=js"

import "./AdventureChatTypingIndicator.vue?vue&type=style&index=0&id=607368dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607368dc"]])

export default __exports__